<template>
    <div class="image-manager container-fluid">
        <h1>Image Manager</h1>
        
        <div class="row">
            <div v-for="image in images.data" :key="image.id" class="col-xs-12 col-sm-6 col-md-4 col-xl-3 text-center mb-4">
                <a href="#" @click.prevent="showFpModal(image)"><img :src="image.permalink+urlParamsForImage(image, 400)" style="height: 150px; max-width: 100%;"></a>
                <div v-if="image.params"><a href="#" @click.prevent="removeParams(image)">Remove Params</a></div>
            </div>
        </div>
        
        <b-modal ref="fp-modal" id="fp-modal" size="xl" title="Set Focal Point">
            <div class="text-center">
                <img ref="fp-image" v-if="editImage" :src="editImage.permalink" style="max-height: 700px; max-width: 100%;" @click="setFp">
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'ImageManager',
    head: {
        title() {
            return {
                inner: 'Image Manager',
            }
        },
    },
    data() {
        return {
            images: [],
            editImage: null,
        }
    },
    methods: {
        showFpModal(image) {
            this.editImage = image
            this.$refs['fp-modal'].show()
        },
        setFp(e) {
            let rect = e.target.getBoundingClientRect()
            let x = e.clientX - rect.left
            let y = e.clientY - rect.top
            let width = rect.width
            let height = rect.height
            let fpX = Math.round(x / width * 100) / 100
            let fpY = Math.round(y / height * 100) / 100
            
            axios({
                url: process.env.VUE_APP_API_BASE_URL + `/media/${this.editImage.id}`,
                method: 'PUT',
                data: {
                    params: JSON.stringify({
                        'fp-x': fpX,
                        'fp-y': fpY,
                        'fit': 'crop',
                        'crop': 'focalpoint',
                    })
                }
            }).then(response => {
                this.dataChanged(response.data.data)
                this.$toast.success("Your changes have been saved.");
                this.editImage = null
                this.$refs['fp-modal'].hide()
            }).catch(error => {
                this.$toast.error("There was a problem saving your changes.");
                console.log({ error: error })
            })
        },
        removeParams(image) {
            axios({
                url: process.env.VUE_APP_API_BASE_URL + `/media/${image.id}`,
                method: 'PUT',
                data: {
                    params: null,
                }
            }).then(response => {
                this.dataChanged(response.data.data)
                this.$toast.success("Your changes have been saved.");
                this.$refs['fp-modal'].hide()
            }).catch(error => {
                this.$toast.error("There was a problem saving your changes.");
                console.log({ error: error })
            })
        },
        dataChanged(imageData) {
            let foundIndex = this.images.data.findIndex(fImage => fImage.id == imageData.id)
            this.images.data.splice(foundIndex, 1, imageData)
        },
        urlParamsForImage(image, width = 400) {
            if (image.params) {
                let params = JSON.parse(image.params)
                return '?w=' + width + '&ar=1.85:1&' + Object.objectAsQueryString(params)
            }
            return '?w=' + width + '&ar=1.85:1&fit=crop&crop=faces,entropy'
        },
    },
    created() {
        axios({
            url: process.env.VUE_APP_API_BASE_URL + `/media?limit=1000`,
            method: 'GET',
        }).then(response => {
            this.images = response.data
        }).catch(error => {
            console.log({ error: error })
        })
    },
};
</script>